import { Head } from '../../components/Head'
import { OrderHeader } from '../../components/OrderHeader'

import { useCart } from '../../hooks/useCart'

import { Container, Inner, Table } from './styles'
import { currency } from '../../helpers/currency_fomat'
import { FormPayment } from '../../components/form/FormPayment'

export default function Payment() {
  const { cart } = useCart()

  return (
    <>
      <Head title='Pagamento' description='' />
      <Container>
        <div>
          <OrderHeader />
        </div>
        <Inner>
          <div>
            <FormPayment />
          </div>
          <div>
            <h4>Resumo do Carrinho</h4>
            <div>
              {cart.map((item) => (
                <Table key={item.name}>
                  <span>
                    <img src={item.image} alt={item.name} />
                    <span>
                      <h4>{item.name}</h4>
                      <div className='price'>{currency(item.price)}</div>
                      <div style={{ marginTop: 5 }}>
                        {`${item.quantity}`.padStart(2, '0')} {item.quantity > 1 ? 'items' : 'item'}{' '}
                        <br />
                      </div>
                      <div>subtotal:</div>
                      <span className='price'>{currency(item.subtotal)}</span>
                    </span>
                  </span>
                </Table>
              ))}
            </div>
          </div>
        </Inner>
      </Container>
    </>
  )
}
